exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-fill {\n  margin-left: 20px;\n  background-color: #b4181d;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/malls/addmall/addmall.component.scss
// module id = ../../../../../src/app/malls/addmall/addmall.component.scss
// module chunks = main